import * as tslib_1 from "tslib";
import { showUnsubscribeDialog } from './UnsubscribeDialog';
import unsubscribeFromBrandSubscription from '../actions/unsubscribeFromBrandSubscription';
import useSilentUri from '../utils/useSilentUri';
import { observer } from 'mobx-react';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
var styles = require('./BrandSubscriptionDetails.scss');
var BrandSubscriptionDetails = /** @class */ (function (_super) {
    tslib_1.__extends(BrandSubscriptionDetails, _super);
    function BrandSubscriptionDetails() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onUnsubscribe = function (ev) {
            var unsubscribeCallback = function () {
                unsubscribeFromBrandSubscription(_this.props.smtpIdentifier, _this.props.unsubscribeSilentUris, _this.props.unsubscribeHttpUri);
            };
            showUnsubscribeDialog(unsubscribeCallback, _this.getDialogDetailMessage());
        };
        _this.getDialogDetailMessage = function () {
            return useSilentUri(_this.props.unsubscribeSilentUris.length)
                ? format(strings.options_subscriptions_unsubscribeDialogDetails_SilentUriUnsubscribe, _this.props.displayName)
                : format(strings.options_subscriptions_unsubscribeDialogDetails_HttpUriUnsubscribe, _this.props.displayName, _this.props.unsubscribeHttpUri);
        };
        return _this;
    }
    BrandSubscriptionDetails.prototype.render = function () {
        return (React.createElement("div", { className: styles.details },
            React.createElement("span", { className: styles.displayName }, this.props.displayName),
            React.createElement("span", { className: styles.smtp }, this.props.smtp),
            !this.props.isUnsubscribed && (React.createElement(DefaultButton, { className: styles.button, onClick: this.onUnsubscribe, text: strings.options_subscriptions_unsubscribe }))));
    };
    BrandSubscriptionDetails = tslib_1.__decorate([
        observer
    ], BrandSubscriptionDetails);
    return BrandSubscriptionDetails;
}(React.Component));
export default BrandSubscriptionDetails;
//# sourceMappingURL=BrandSubscriptionDetails.js.map